import { styled } from "goober";
import type { IconName } from "../Icon";
import { ClickButton } from "../ClickButton";
import { ButtonContent } from "./ButtonContent";
import { baseStyle, buttonClass, type ButtonStyle } from "./buttonStyle";

const Element = styled(ClickButton)`
  ${baseStyle}
`;

type Props = ButtonStyle &
  Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "onClick"> & {
    iconSpinning?: boolean;
    iconTurnKey?: number;
    spinningIcon?: IconName;
    onClick?: (() => void) | React.MouseEventHandler<HTMLButtonElement>;
  };

export function Button({
  variant,
  size,
  icon,
  iconSpinning,
  iconTurnKey,
  spinningIcon,
  className,
  children,
  onClick,
  ...props
}: Props) {
  return (
    <Element
      {...props}
      onClick={onClick}
      className={buttonClass({ variant, size, icon, children, className })}
    >
      <ButtonContent
        size={size}
        icon={icon}
        iconSpinning={iconSpinning}
        iconTurnKey={iconTurnKey}
        spinningIcon={spinningIcon}
      >
        {children}
      </ButtonContent>
    </Element>
  );
}
